var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoEstrella(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.83,
    height: 13.278,
    viewBox: "0 0 13.83 13.278",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_118175",
    "data-name": "Trazado 118175",
    d: "M141.957,158.546a1.168,1.168,0,0,1-.692-.227,1.148,1.148,0,0,1-.4-1.271l1.082-3.474-2.744-2.228a1.148,1.148,0,0,1,.743-2.026H143.4l1.221-3.285a1.153,1.153,0,0,1,2.165,0l1.221,3.285h3.461a1.156,1.156,0,0,1,1.082.755,1.178,1.178,0,0,1-.34,1.284l-2.731,2.228,1.133,3.436a1.142,1.142,0,0,1-.39,1.271,1.154,1.154,0,0,1-1.334.05l-3.172-2.064L142.6,158.37a1.16,1.16,0,0,1-.642.189Z",
    transform: "translate(-138.793 -145.28)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoEstrella);
export default __webpack_public_path__ + "static/media/Icono-Estrella.6d4b14224ce706a53dea71767080aacc.svg";
export { ForwardRef as ReactComponent };